// Thin client for the backend's /api/admin endpoints. Every call carries the
// admin's Supabase access token in the Authorization header; the backend
// verifies the token and the admin role before doing anything.
const URI = process.env.REACT_APP_API_URL || 'http://localhost:8080';

async function request(path, token, options = {}) {
  const response = await fetch(`${URI}api/admin/${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  let body = null;
  try {
    body = await response.json();
  } catch (_) {
    // no JSON body
  }

  if (!response.ok) {
    const error = new Error(body?.message || `HTTP error ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return body;
}

export function listUsers(token) {
  return request('users', token, { method: 'GET' });
}

export function inviteUser(token, email, redirectTo) {
  return request('invite', token, {
    method: 'POST',
    body: JSON.stringify({ email, redirectTo }),
  });
}

export function generateInviteLink(token, email, redirectTo) {
  return request('invite-link', token, {
    method: 'POST',
    body: JSON.stringify({ email, redirectTo }),
  });
}

export function setUserRole(token, id, role) {
  return request(`users/${id}/role`, token, {
    method: 'PATCH',
    body: JSON.stringify({ role }),
  });
}

export function setUserActive(token, id, active) {
  return request(`users/${id}/active`, token, {
    method: 'PATCH',
    body: JSON.stringify({ active }),
  });
}

// ---- Consultores ----

export function listConsultants(token) {
  return request('consultants', token, { method: 'GET' });
}

export function createConsultant(token, body) {
  return request('consultants', token, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updateConsultant(token, id, body) {
  return request(`consultants/${id}`, token, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function setConsultantActive(token, id, active) {
  return request(`consultants/${id}/active`, token, {
    method: 'PATCH',
    body: JSON.stringify({ active }),
  });
}

export function deleteConsultant(token, id) {
  return request(`consultants/${id}`, token, { method: 'DELETE' });
}
